import './OkulyonetimAlert.scss'

import { Alert } from 'antd'

interface OkulyonetimAlertProps {
  alertText?: string
}

const alertTextDefault =
  'Görmüş olduğunuz fiyatlar güncel olmayabilir. Satışlara başlandığında fiyatlar güncellenecektir.'

const OkulyonetimAlert: React.FC<OkulyonetimAlertProps> = ({ alertText = alertTextDefault }) => {
  return (
    <div className="okulyonetim-alert">
      <Alert message={<p>{alertText}</p>} type="warning" showIcon={true} />
    </div>
  )
}

export default OkulyonetimAlert
